<div class="dialog-agent">
  <h1 mat-dialog-title>
    <span>
      {{ 'GLOBAL.CHANGE-PIN-TITLE' | translate }}
    </span>
  </h1>
  <div mat-dialog-content class="">

    <div class="row mx-0 pb-3">
      <div class="col-12 pb-2">
        <p class="m-0">
          {{ 'GLOBAL.CHANGE-PIN-INFO' | translate }}
        </p>
      </div>
      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-1 h6">
          {{ 'GLOBAL.CURRENT-CERT-PIN' | translate }} <small class="font-italic text-secondary">({{ 'GLOBAL.OPTIONAL' | translate }})</small>
        </mat-label>
        <mat-form-field class="w-100">
          <input [type]="hidePinCurrent ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-CURRENT-PIN' | translate" matInput minlength="4" maxlength="8" autocomplete="new-password" [(ngModel)]="dataCurrentPin" [ngModelOptions]="{standalone: true}" #currentPin="ngModel" />
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-pin'" (click)="hidePinCurrent = !hidePinCurrent" [ngClass]="{'rt-view': hidePinCurrent, 'rt-hide': !hidePinCurrent}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(currentPin.dirty || currentPin.touched) && currentPin.errors && currentPin.errors.minlength">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-1 h6">
          {{ 'GLOBAL.NEW-CERT-PIN' | translate }}
        </mat-label>
        <mat-form-field class="w-100">
          <input [type]="hidePinNew ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-NEW-PIN' | translate" matInput required minlength="4" maxlength="8" autocomplete="new-password" [(ngModel)]="dataNewPin" [ngModelOptions]="{standalone: true}" #newPin="ngModel"/>
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-new-pin'" (click)="hidePinNew = !hidePinNew" [ngClass]="{'rt-view': hidePinNew, 'rt-hide': !hidePinNew}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(newPin.dirty || newPin.touched) && newPin.errors && newPin.errors.minlength">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(newPin.dirty || newPin.touched) && newPin.errors && newPin.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-1 h6">
          {{ 'GLOBAL.REPEAT-NEW-CERT-PIN' | translate }}
        </mat-label>
        <mat-form-field class="w-100">
          <input [type]="hidePinRepeat ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-REPEAT-NEW-PIN' | translate" matInput required minlength="4" maxlength="8" autocomplete="new-password" [(ngModel)]="dataRepeatNewPin" [ngModelOptions]="{standalone: true}" #repeatPin="ngModel"/>
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-repeat-new-pin'" (click)="hidePinRepeat = !hidePinRepeat" [ngClass]="{'rt-view': hidePinRepeat, 'rt-hide': !hidePinRepeat}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(repeatPin.dirty || repeatPin.touched) && repeatPin.errors && repeatPin.errors.minlength">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(repeatPin.dirty || repeatPin.touched) && repeatPin.errors && repeatPin.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="(!repeatPin.errors) && dataNewPin && dataRepeatNewPin && (dataNewPin !== dataRepeatNewPin)">{{ 'GLOBAL.ERRORS.PIN-NO-EQUAL' | translate }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" [disabled]="sendingInfo || !(dataNewPin) || !(dataRepeatNewPin) || (dataNewPin !== dataRepeatNewPin)" (click)="sendPinChange();">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingInfo"></i>
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CHANGE' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" class="" [disabled]="sendingInfo" (click)="cancelChanges()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
